import { UPDATE_SGZ_MARKER_DATA } from "./sgzMarkerDataReducer"

export const updateSgzMarkerData = (info) => async (dispatch) => {
    dispatch({
        type: UPDATE_SGZ_MARKER_DATA,
        payload: info
    })
}
